import { useEffect } from 'react';
import { addAppBreadcrumb, logUiAction } from '../../utils/sentry';

const getClickLabel = (target) => {
    if (!target) return '';
    const el = target.closest('button,a,[role="button"],[data-sentry-action]');
    if (!el) return '';
    const dataAction = el.getAttribute('data-sentry-action');
    if (dataAction) return dataAction;
    const ariaLabel = el.getAttribute('aria-label');
    if (ariaLabel) return ariaLabel;
    const text = (el.textContent || '').trim().replace(/\s+/g, ' ');
    if (text) return text.slice(0, 120);
    const id = el.getAttribute('id');
    return id ? `#${id}` : el.tagName.toLowerCase();
};

const SentryActionTracker = () => {
    useEffect(() => {
        let lastSentAt = 0;
        const MIN_SEND_INTERVAL_MS = 1500;

        const sendActionEvent = (actionType, label) => {
            const now = Date.now();
            if (now - lastSentAt < MIN_SEND_INTERVAL_MS) return;
            lastSentAt = now;
            logUiAction(actionType, {
                label,
            });
        };

        const onClick = (event) => {
            const label = getClickLabel(event.target);
            if (!label) return;
            addAppBreadcrumb({
                category: 'ui.click',
                type: 'user',
                level: 'info',
                message: label,
            });
            sendActionEvent('click', label);
        };

        const onSubmit = (event) => {
            const form = event.target;
            const id = form?.getAttribute?.('id') || form?.getAttribute?.('name') || 'form';
            addAppBreadcrumb({
                category: 'ui.submit',
                type: 'user',
                level: 'info',
                message: String(id),
            });
            sendActionEvent('submit', String(id));
        };

        window.addEventListener('click', onClick, true);
        window.addEventListener('submit', onSubmit, true);

        return () => {
            window.removeEventListener('click', onClick, true);
            window.removeEventListener('submit', onSubmit, true);
        };
    }, []);

    return null;
};

export default SentryActionTracker;
